




















import { Component, Vue } from "vue-property-decorator";
import store from "@/store";

@Component
export default class SplashScreen extends Vue {
  hasNavigated = false;

  get version(): string {
    return store.state.delayCodes.packageVersion;
  }

  mounted() {
    this.$nextTick(function() {
      this.sleep(5000).then(() => {
        this.enterApp();
      });
    });
  }

  enterApp() {
    if (!this.hasNavigated) {
      this.hasNavigated = true;
      this.$router.push("guided");
    }
  }

  sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
